import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { MetodoCargaDescarga } from "app/models/requireme";

type Entity = models.StatusGuiaViewDTO;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
export const columnas: Column[] = [
    { title: "Fecha", cell: x => ({ data: kea.toDate(x.Fecha) }) },
    { title: "Status", cell: x => ({ data: models.StatusGuia[x.Status] }) },
    { title: "Sucursal", cell: x => ({ data: x.NombreSucursal }) },
    { title: "Usuario", cell: x => ({ data: x.NombreUsuario }) },
    { title: "Escaneo", cell: x => ({ data: x.MetodoEscaneo != null ? MetodoCargaDescarga[x.MetodoEscaneo] : null }) },
    { title: "Viaje (folio)", cell: x => ({ data: x.NombreViajeRuta }) },
    { title: "Viaje (origen)", cell: x => ({ data: x.NombreViajeOrigen }) },
    { title: "Viaje (destino)", cell: x => ({ data: x.NombreViajeDestino }) },
    { title: "Ruta", cell: x => ({ data: x.NombreRutaViajeRuta }) },
    { title: "Ruta (desc)", cell: x => ({ data: x.DescripcionRutaViajeRuta }) },
    { title: "Caja de ruta", cell: x => ({ data: x.NombreCaja }) },
    { title: "Camión de ruta", cell: x => ({ data: x.NombreCamion }) },
    { title: "Camión de EAD", cell: x => ({ data: x.NombreCamionEAD }) },
    { title: "Viaje de EAD", cell: x => ({ data: x.FolioViajeEAD }) },
    { title: "Vehículo de ZE", cell: x => ({ data: x.NombreVehiculoZE }) },
    { title: "Viaje de ZE", cell: x => ({ data: x.FolioViajeZE }) },
    { title: "Nombre contacto recibió", cell: x => ({ data: x.NombreContactoClienteRecibio }) },
    { title: "Origen del status", cell: x => ({ data: models.OrigenStatusGuia[x.OrigenStatus] }) },
];



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/guias/listados/guias/edit/listas/status/columns.tsx